import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'

export class StorageModule {
  constructor(private rpc: RpcEngine) {}

  set<T = unknown>(key: string, value: T): Promise<void>      { return this.rpc.call(METHODS.STORAGE_SET, [key, value]) }
  get<T = unknown>(key: string):           Promise<T | null>   {
    return this.rpc.call<T | null | undefined>(METHODS.STORAGE_GET, [key]).then(value => value ?? null)
  }
  async getOrDefault<T = unknown>(key: string, defaultValue: T): Promise<T> {
    const v = await this.get<T>(key)
    return v !== null && v !== undefined ? v : defaultValue
  }
  async has(key: string): Promise<boolean> {
    const v = await this.get(key)
    return v !== null && v !== undefined
  }
  remove(key: string): Promise<void>    { return this.rpc.call(METHODS.STORAGE_REMOVE, [key]) }
  clear():             Promise<void>    { return this.rpc.call(METHODS.STORAGE_CLEAR) }
  keys():              Promise<string[]> { return this.rpc.call(METHODS.STORAGE_KEYS) }
}
